<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="create">
            <v-layout row wrap>

                <v-flex xs6 sm6 md4>
                    <v-text-field
                            v-validate="''"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md4>
                        <v-text-field
                                v-validate="'required|email'"
                                v-model="data.email"
                                :error-messages="errors.collect('data.email')"
                                label="E-mail"
                                data-vv-name="data.email"
                                v-on:change="debouncedComprobarEmail()"
                                browser-autocomplete="off"
                        ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.company_name"
                            :error-messages="errors.collect('data.company_name')"
                            label="Company name"
                            data-vv-name="data.company_name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>
                <!--
                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="''"
                            v-model="data.vat"
                            :error-messages="errors.collect('data.vat')"
                            label="Vat"
                            data-vv-name="data.vat"
                    ></v-text-field>
                </v-flex>
                -->

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="''"
                            v-on:change="debouncedGetSelectStates"
                            :items="countries"
                            item-text="name"
                            label="Country"
                            item-value="id"
                            v-model="data.country"
                            data-vv-name="data.country"
                            :error-messages="errors.collect('data.country')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-autocomplete
                            v-validate="''"
                            :items="states"
                            item-text="name"
                            label="State"
                            item-value="id"
                            v-model="data.state"
                            data-vv-name="data.state"
                            :error-messages="errors.collect('data.state')"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm12 md12>
                    <v-textarea
                            solo
                            name="input-7-4"
                            label="Notes"
                            v-model="data.notes"
                            browser-autocomplete="off"
                    ></v-textarea>
                </v-flex>

                <v-flex>
                    <v-alert
                            v-if="email_usado"
                            :value="true"
                            type="error"
                            icon="priority_high"
                    >
                        El email "{{ data.email }}" ya esta siendo usado por {{ clientes.length > 1 ? 'los clientes' : 'el cliente'}} <span v-for="(cliente, index) in clientes">{{ cliente.company_name }}{{ ++index == clientes.length ? '. ' : ', ' }}</span> ¿Quieres usarlo de todas formas?
                    </v-alert>
                    <v-btn large color="secondary" class="text--primary" type="submit">Create client</v-btn>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../diccionario';

    export default {
        data : function() {
            return {
                data : {
                    email : '',
                    company_name : '',
                    shipping_address: '',
                    billing_data: '',
                    country: '',
                    state: '',
                    notes: '',
                    name: ''
                },
                error : false,
                message_error : null,
                dictionary: DICCIONARIO,
                countries: null,
                states: null,
                email_usado: false,
                clientes: null,
                statuses: null,
            }
        },
        created: function () {
            this.setSectionTitle();
            this.getSelectCountry();
            this.debouncedComprobarEmail = _.debounce(this.comprobarEmail, 500);
            this.debouncedGetSelectStates = _.debounce(this.getSelectStates, 100);
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            comprobarEmail () {
                this.$store.dispatch('checkEmail', {
                    email: this.data.email
                }).then((res) => {
                    if (res.data.existe) {
                        this.email_usado = true;
                        this.clientes = res.data.cliente;
                    }
                    if (! res.data.existe) {
                        this.email_usado = false;
                        this.cliente = null;
                    }
                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Create client.'
                });
            },
            getSelectCountry () {
                this.$store.dispatch('getSelectCountry').then((res) => {

                    this.countries = res.data;

                }).catch((error) => {

                });
            },
            getSelectStates () {
                this.$store.dispatch('getSelectState', {
                    id: this.data.country
                }).then((res) => {

                    this.states = res.data;

                }).catch((error) => {

                });
            },
            create : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('createClient', {
                            data : this.data
                        }).then((res) => {

                            this.$router.push({ name : 'admin.clients.list'});

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.message_error = error.data.errors.email[0];
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/CreateComponent.vue